import React from 'react';
import { StyledSubTit } from './style';

const Subtitle = ({ className, children }) => (
  <StyledSubTit className={className}>{children}</StyledSubTit>
);

export default Subtitle;
